import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import ModalDialog from '../../../common/modal-dialog/modal-dialog.component';
import { HeaderSecondary } from '../../../common/typography/typography.styles';
import { ModalTextBody } from '../../../common/modal-dialog/modal-dialog.styles';
import { FlexContainer } from '../../../common/flex-container/flex-container.styles';
import { useStore } from '../../../stores/store';
import { getFormattedPrice } from '../../../utils/price/get-formatted-price';
import { getCountryTranslationKey } from '../../../utils/translations/translations.utils';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onApprove: () => void;
}

const InsuranceCoverageChangeModal = ({
  isOpen = false,
  onClose,
  onApprove,
}: Props) => {
  const {
    parcelCreationStore: { insuranceLimits, shipment, countryDeparture },
    userStore: { getCurrencySymbol },
  } = useStore();

  const currencySymbol = getCurrencySymbol(shipment?.converted_price?.currency);

  const maxFreeInsuredValue = getFormattedPrice(
    insuranceLimits?.max_free_value,
    currencySymbol
  );

  return (
    <ModalDialog
      isDanger
      approveBtnContent={t('Disable')}
      cancelBtnContent={t('cancel')}
      isOpen={isOpen}
      onApprove={onApprove}
      onClose={onClose}>
      <FlexContainer $justify='flex-start'>
        <HeaderSecondary>
          {t(
            getCountryTranslationKey(
              'insurance_modal_title',
              countryDeparture?.code
            )
          )}
        </HeaderSecondary>
      </FlexContainer>
      <ModalTextBody>
        {t(
          getCountryTranslationKey(
            'insurance_modal_description',
            countryDeparture?.code
          ),
          {
            freeInsuranceLimit: maxFreeInsuredValue,
          }
        )}
      </ModalTextBody>
    </ModalDialog>
  );
};

export default observer(InsuranceCoverageChangeModal);
